const AuthRouter = {
  path: '/auth',
  name: 'Auth',
  redirect: '/auth/login',
  component: () => import('@/layout/index'),
  children: [
    {
      path: 'login',
      name: 'AuthLogin',
      component: () => import('@/views/auth/login'),
      meta: { title: '登录授权' }
    },
    {
      path: 'profile',
      name: 'AuthProfile',
      component: () => import('@/views/auth/profile'),
      meta: { title: '个人中心' }
    },
    {
      path: 'game-detail',
      name: 'AuthGameDetail',
      component: () => import('@/views/auth/gameDetail'),
      meta: { title: '赛事详情' }
    }
  ]
}
export default AuthRouter

